import {EventEmitter} from 'events';

const KEYS = {
	13: 'enter',
	27: 'esc',
	32: 'space',
	37: 'left',
	38: 'up',
	39: 'right',
	40: 'down'
};

const defaults = {
	target: window,
	keyEvent: 'keyup'
};

export default class Keyer extends EventEmitter {
	constructor(options) {
		super();
		let opts = options;
		if (options && options.nodeType) {
			opts = {
				target: options
			};
		}
		this.options = Object.assign(defaults, opts);
		this.target = this.options.target;
		this.active = true;
	}

	start() {
		this.target.addEventListener(this.options.keyEvent, this.down.bind(this));
	}

	down(event = window.event) {
		const keyName = this.getKeyName(event.keyCode) || event.key;
		if (keyName && this.active) {
			this.emit(keyName, event, keyName);
		}
	}

	getKeyName(key) {
		return KEYS[key];
	}

	deactivate() {
		this.active = false;
	}

	activate() {
		this.active = true;
	}
}
